import { render, staticRenderFns } from "./MockBankForm.vue?vue&type=template&id=e0ce946c"
import script from "./MockBankForm.vue?vue&type=script&lang=js"
export * from "./MockBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports